import React from 'react';
import { Hotel } from 'lucide-react';
import { Hotel as HotelType } from './types';
import { useLanguage } from '../../contexts/LanguageContext';

type Props = {
  hotels: HotelType[];
  selectedHotelId: string;
  onSelectHotel: (hotelId: string) => void;
};

export const HotelSelector = ({
  hotels,
  selectedHotelId,
  onSelectHotel,
}: Props) => {
  const { translations } = useLanguage();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {hotels.map((hotel) => (
        <button
          key={hotel.id}
          onClick={() => onSelectHotel(hotel.id)}
          className={`
            p-4 rounded-lg border-2 transition-all
            ${
              selectedHotelId === hotel.id
                ? 'border-primary-500 bg-primary-50'
                : 'border-gray-200 hover:border-primary-200'
            }
          `}
        >
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white rounded-lg">
              <Hotel className="text-primary-500" size={24} />
            </div>
            <div className="text-right">
              <h3 className="font-medium">{hotel.name}</h3>
              <p className="text-sm text-gray-500">
                {hotel.hasMultipleBuildings
                  ? translations?.hotelSelector?.multipleBuildings.replace(
                      '{count}',
                      hotel.buildings.length.toString()
                    ) || `${hotel.buildings.length} buildings`
                  : translations?.hotelSelector?.singleBuilding ||
                    'Single Building'}
              </p>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};
